import BaseLayout from '../layout/layout-with-sider/BaseLayout';
import {
    Button,
    Card,
    Result,
    Tabs,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { AppActions, useAppContext } from '../../Context/ProjectContextV2';
import { tab } from '@testing-library/user-event/dist/tab';
import { _ } from 'plotly.js/src/lib';
import { useHistory } from 'react-router-dom';
import MessageRunOperations from './MessageRunOperations';
import MessageLMA from './MessageLMA';

export default function MessageRun() {
    const [runType, setRunType] = useState('Check');
    const history = useHistory();
    const { appContext, dispatchProject, selectedHistoryId, selection } =
        useAppContext();
    
    return (
        <div>
            {appContext?.projects?.length === 0 && (
                <Result
                    style={{ backgroundColor: 'white' }}
                    title='There are no Uploaded Projects!'
                    extra={
                        <Button
                            size={'small'}
                            type='primary'
                            key='console'
                            onClick={() => {
                                history.push('/app/load-project');
                            }}
                        >
                            Upload project and run
                        </Button>
                    }
                />
            )}
            {appContext?.projects?.length > 0 && (
                <BaseLayout>
                <Card
                        title={
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <Tabs
                                        onChange={(tab) => setRunType(tab)}
                                        tab={tab}
                                        type={'card'}
                                        defaultActiveKey={'Check'}
                                        hideAdd={true}
                                        size={'small'}
                                        moreIcon={false}
                                    >
                                        <Tabs.TabPane
                                            tab={'Check'}
                                            key={'Check'}
                                        />
                                        <Tabs.TabPane
                                            tab={'Comparison'}
                                            key={'Comparison'}
                                        />
                                        <Tabs.TabPane
                                            tab={'Library Model Automation'}
                                            key={'LMA'}
                                        />
                                    </Tabs>
                                </div>
                            </div>
                        }
                    >
                        {['Check', 'Comparison'].includes(runType) && (
                            <MessageRunOperations runType={runType} />
                        )}
                        {
                            runType === 'LMA' && (
                                <MessageLMA />
                            )
                        }
                    </Card>
                </BaseLayout>
            )}
        </div>
    );
}
